export default __webpack_public_path__ + "static/media/demo-doodle-3.9c4fd026.png";